module.exports = __webpack_public_path__ + "img/tanker_blank.fc8d926e.png";